// extracted by mini-css-extract-plugin
module.exports = {"posts":"Schedule_posts__1hpX4","empty":"Schedule_empty__1pXaX"};